import { useMessageStore } from '@/stores/messageStore';
import { useRedirectStore } from '@/stores/redirectStore';
import { useApplicationStore } from '@/stores/applicationStore';
import { convertRouteToNavigable } from '@/helpers/steps.js';
import * as routeFunctions from '@/helpers/routeFunctions.js';

export const redirectRecognizedUser = (response) => {
    const { email, first_name, workflow_step, approved, contract_amount } = response.data?.data;

    const messageStore = useMessageStore();
    const redirectStore = useRedirectStore();
    const applicationStore = useApplicationStore();

    applicationStore.application.contract_amount = contract_amount;

    const route = convertRouteToNavigable(workflow_step, approved);

    messageStore.setRecognizeMessage(
        `Hi ${first_name}. We recognized your email and can link your progress to your profile to make things easier. Just enter your password below.`
    );
    redirectStore.setLoginRedirect(route);
    routeFunctions.navigateTo('auth.login', {}, { email: email });
};
